<template>
	<div class="sf-flex-column">
		<div class="sf-col sf-col-4">
			<sf-card class="p-0 h-100 card_bg">
				<part-cku-prvs-search ref="searchView" :scrId="scrId" />
			</sf-card>
		</div>
		<div class="sf-col sf-col-20 grid-wrapper">
			<div style="grid-column: 1/5; grid-row: 1/3">
				<part-cku-prvs-m-table @Refresh="refresh" :scrId="scrId" />
			</div>
			<div style="grid-column: 5/6; grid-row: 1/3">
				<part-cku-prvs-d-table @Refresh="refresh" :scrId="scrId" />
			</div>
		</div>
		<!-- <comm-cd-desc-modal :scrId="scrId" /> -->
	</div>
</template>

<script>
import PartCkuPrvsSearch from './Search/PartCkuPrvsSearch.vue';
import PartCkuPrvsDTable from './Table/PartCkuPrvsDTable.vue';
import PartCkuPrvsMTable from './Table/PartCkuPrvsMTable.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PartCkuPrvsSearch, PartCkuPrvsDTable, PartCkuPrvsMTable },
	methods: {
		refresh() {
			this.$refs.searchView.searchMstList();
		}
	}
};
</script>

<style></style>
